module.exports = __webpack_public_path__ + "static/models/intro_runner.bf2a773.jd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/runner/intro_runner.jd
// module id = 577
// module chunks = 1